// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M14 2H2V22H16V16H18V22H22V10H14V2ZM12 10H9V8H12V10ZM12 20H4V16H12V20ZM12 14H9V12H12V14ZM7 8V10H4V8H7ZM4 14V12H7V14H4ZM7 6H4V4H7V6ZM9 6V4H12V6H9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-8-filled')
export default class City8FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-8-filled',
    }
  }
}
